import React, { useEffect, useState } from 'react';
import CircularProgressLoader from '../components/CircularProgressLoader';
import { useTranslation } from 'react-i18next';

const SupportScreenPage = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [loadingMessage, setLoadingMessage] = useState(t('pleaseWaitText'));

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
            setLoadingMessage('');
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="support-screen-page">
            <div className="main-container">
                <div className="main">

                    {loading && (
                        <div>
                            <CircularProgressLoader message={loadingMessage} />
                        </div>
                    )}

                    <iframe
                        src={t('url_contact_us')}
                        title="Support"
                        className={`iframe-view ${loading ? 'hide' : ''}`}
                    />
                </div>
            </div>
        </div>
    );
};

export default SupportScreenPage;